import { BasicResult } from "../basic-result";
import { EditAuditLocationLocation } from "./edit-audit-location-location";

export class EditAuditLocationResult extends BasicResult{
    public Locations:EditAuditLocationLocation[] = []; 
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
    }
}